import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

import { isTouchDevice, debounce } from '../helpers'

export default class extends Controller {
  static targets = [ "card" ]

  initialize() {
    if(!this.isTouch){
      this.setupTl()
      window.addEventListener("resize", debounce( this.setupTl, 150 ));
    }
  }

  setupTl(){
    this.cardTargets.forEach((el,i)=>{
      const arrowTl = gsap.timeline({
        paused: true,
      })
      .to(el.querySelector('.scroll-indicator svg'),{
        x: 16,
        autoAlpha:0
      })
      .set(el.querySelector('.scroll-indicator svg'),{
        x: -16
      })
      .to(el.querySelector('.scroll-indicator svg'),{
        x: 0,
        autoAlpha:1
      })

      const tl = gsap.timeline({
        paused:true,
      })
      .to(el.querySelector('.fs--l'),{
        yPercent:-100,
        duration:.25
      },'start')
      .set(el.querySelector('.fs--l'),{
        yPercent:100
      })
      .to(el.querySelector('.fs--l'),{
        yPercent:0,
        duration:.25
      })
      .to(el.querySelector('img'),{
        scale:1.25,
        duration:.5
      },'start')

      el.addEventListener("mouseenter", ()=>{
          if (!this.isTouch) {
            arrowTl.progress(0).play()
            tl.progress(0).play()
          }
      });
      el.addEventListener("mouseleave", ()=>{
        if (!this.isTouch) {
          tl.reverse()
        }
    });
    })
    
    // .to(this.element,{
    //   backgroundColor: '#E8CFC2',
    //   duration:.25
    // },'same')
    // .to(this.titleTarget,{
    //   yPercent:-100,
    //   duration:.25,
    //   autoAlpha:0
    // },'same')
    // .fromTo(this.titleTarget,{
    //   yPercent:100,
    //   autoAlpha:0
    // },{
    //   yPercent:0,
    //   duration:.25,
    //   autoAlpha:1,
    //   immediateRender:false
    // },"-=.125")

    // if(this.addToCart){
    //   this.tl.add(
    //     gsap.fromTo(this.addToCart,{
    //       autoAlpha:0,
    //       scale:.95,
    //       yPercent:-12.5,
    //     },{
    //       autoAlpha:1,
    //       delay:.125,
    //       duration:.25,
    //       scale:1,
    //       yPercent:0
    //     })
    //   ,'same')
    // }
  }

  // play(){
  //   if(!this.isTouch){
  //     this.tl.play()
  //   }
  // }

  // reverse(){
  //   if(!this.isTouch){
  //     this.tl.reverse()
  //   }
  // }
}